import { useState } from 'react';

import Checkbox from '@components/common/presentational/checkbox/checkbox';
import Clickable from '@v2/components/common/presentational/clickables/default';
import { packAndTrack } from '@v2/services/analytics.service';

import { IProduct } from '@interfaces/_cart';
import Bundle from '@components/pages/shop/partial/bundle';
import BundleHighlight from '@components/pages/shop/partial/bundle-highlight';
import { useEntity } from '@app/store/rtk.entities.selectors';
import { useDispatch } from 'react-redux';
import { setVeganOnly } from '@v2/store/shop.store';
import { useShop } from '@v2/store/shop.selectors';
import { scroller } from 'react-scroll';

export default function AgeBundles({ category, filterAge, subscribed, setFilterAge }: { category: any, filterAge: any, subscribed: boolean, setFilterAge: Function }) {
    const productsEntities = useEntity('ageBundles');
    const products = productsEntities ? Object.values(productsEntities) as IProduct[] : [];
    const { veganOnly } = useShop();
    const [showAll, setShowAll] = useState(false);
    const dispatch = useDispatch();

    return (
        <div className="category bundles" id="bundles">
            <div className="category-title">
                <h2>{category.title}
                    {category.pricePerMeal &&
                        <span>from ${category.pricePerMeal.toFixed(2)} per meal</span>
                    }
                </h2>
                <div>
                    <p>{category.description}</p>
                    <div className={'veggie-option'}>
                        <Checkbox
                            name={'veganOnly'}
                            size={'MINI'}
                            type={'SWITCH'}
                            onChange={() => {
                                dispatch(setVeganOnly(!veganOnly));
                                packAndTrack(`Vegan Option Clicked ${veganOnly ? 'On' : 'Off'}`,
                                    [{ 'view': 'Shop', 'section': 'Bundles' }]
                                );
                            }}
                            checked={veganOnly}
                            useParentState={true}>
                            Vegan only
                        </Checkbox>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter">
                    <Clickable className={filterAge === null ? 'active' : null} onClick={() => {
                         const url = new URL(window.location.href);
                         url.searchParams.set('bundle', 'all');
                         window.history.pushState(null, '', url.toString());
                         scroller.scrollTo('bundles', { offset: -90 });
                        setFilterAge(null)
                    }}>
                        All ages
                    </Clickable>
                    {products && products.map((product: IProduct, index: number) =>
                        (!veganOnly || (veganOnly && product.veggie && product.veggie.size))
                            ?
                            <Clickable key={product.id} className={filterAge === index ? 'active' : null} onClick={() => {
                                const url = new URL(window.location.href);
                                url.searchParams.set('bundle', product.slug);
                                window.history.pushState(null, '', url.toString());
                                scroller.scrollTo('bundles', { offset: -90 });
                                setFilterAge(index);
                            }}>
                                {product.title.replace(' Bundle', '')}
                            </Clickable>
                            :
                            <></>
                    )}
                </div>
            </div>
            {(filterAge !== null && products[filterAge])
                ?
                <div className="products highlight">
                    <BundleHighlight
                        product={products[filterAge]}
                        disabled={false}
                        subscribed={subscribed}
                        setFilter={setFilterAge}
                        isVeggie={veganOnly} />
                </div>
                :
                <div className="products">
                    {
                        products
                            ?
                            <div className="row">
                                {products
                                .filter((product: IProduct, index: number) => (index < 4 && !showAll) || showAll )
                                .map((product: IProduct, index: number) =>
                                    (!veganOnly || (veganOnly && product.veggie && product.veggie.size))
                                        ?
                                        <div key={product.id} className="col-lg-6 col-md-6 col-12 mb-4">
                                            <Bundle
                                                product={product}
                                                disabled={false}
                                                isAgeBundle={true}
                                                setFilterAge={setFilterAge}
                                                index={index}
                                                subscribed={subscribed}
                                                isVeggie={veganOnly} />
                                        </div>
                                        :
                                        <></>
                                )}
                                {!showAll && products.length > 4 &&
                                    <Clickable className="show-all-action" onClick={() => setShowAll(true)}>Show All Bundles</Clickable>
                                }
                            </div>
                            :
                            <div className="row"></div>
                    }
                </div>
            }
        </div>
    );
}
